import React, { useState } from 'react'

import { Source } from '../../models/Source'
import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import Paragraph from '../app/design/Paragraph'
import { TextField } from '../common/fields/TextField'
import { WorkflowPage } from '../workflows/WorkflowPage'

type AuthorizeAccountModalProps = {
    source: Source | null
    isOpen: boolean
    onClose: () => void
    onAuthorize: (accountNumber: string) => void
    isProcessing?: boolean
}

export const AuthorizeSourceModal = ({
    source,
    isOpen,
    onClose,
    onAuthorize,
    isProcessing = false,
}: AuthorizeAccountModalProps) => {
    const [accountNumber, setAccountNumber] = useState('')

    const handleAuthorize = () => {
        if (accountNumber) {
            onAuthorize(accountNumber)
        }
    }

    const isValidAccountNumber = accountNumber.trim().length > 0

    return (
        <Modal
            size="medium"
            isOpen={isOpen}
            onClose={() => onClose()}
            title="Authorize account"
            showDividers={true}
            footer={
                <div className="flex w-full items-center justify-end gap-x-4">
                    <Button intent="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        intent="primary"
                        onClick={handleAuthorize}
                        disabled={!isValidAccountNumber}
                        isLoading={isProcessing}
                    >
                        Authorize
                    </Button>
                </div>
            }
        >
            <div className="flex flex-col gap-4 py-2">
                <WorkflowPage.IconSection title="Routing number" icon="hash.large">
                    <TextField
                        disabled={true}
                        className="text-gray-500"
                        size="medium"
                        value={source?.routingNumber || ''}
                        mask="000000000"
                    />
                    <Paragraph className="mt-2 text-sm text-gray-500">
                        Two small "VERIFICATION" deposits will be sent to this account in 2-3 days.
                        Please confirm your account number to get started.
                    </Paragraph>
                </WorkflowPage.IconSection>

                <WorkflowPage.IconSection title="Confirm account number" icon="bank.large">
                    <TextField
                        placeholder="Enter account number"
                        size="medium"
                        value={accountNumber}
                        onChange={(event) => setAccountNumber(event.target.value)}
                        onClear={() => setAccountNumber('')}
                        mask="000000000000000000"
                    />
                </WorkflowPage.IconSection>
            </div>
        </Modal>
    )
}
